import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Svg from 'svg-inline-react';
import CheckWhiteSvg from '@src/svgs/check-white.svg';
import './styles.scss';

export function SelectableItem({ className, isSelected, label, onClick }) {
  return (
    <div
      className={classnames('selectable-item', className, isSelected && 'selectable-item--selected')}
      onClick={onClick}
    >
      <span className="selectable-item__text">{label}</span>

      <Svg src={CheckWhiteSvg} />
    </div>
  );
}

SelectableItem.propTypes = {
  className: PropTypes.string,
  isSelected: PropTypes.bool,
  label: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};
